import { assert, Test } from "oc-e2e-testrunner";
import {
  assertSegmentIstLückenlosGefüllt,
  getMinMaxSegmentPartsX,
  resetArrangement,
} from "./utils";
import { getSegmentEndenAusgleichForEcke } from "../arrangement/elementFunctions";

export default {
  name: "TestLückenBugs",
};

export const testEinfügenDoppeltorInRechteckIndex2: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 7;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, false, false]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  APP.arrangement.setSelectedObjects(agt.getElemente()[2]);
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  assert.deepEquals(
    [],
    agt.warnungen.map((w) => w.text)
  );
};

export const testEinfügenDoppeltorInRechteckIndex4: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 7;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, false, false]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  APP.arrangement.setSelectedObjects(agt.getElemente()[4]);
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  agt.setSelectedObjects(agt.getEmpties()[0]);
  APP.arrangement.removeSelectedObjects();
  assert.isTrue(agt.getElemente()[4].pfostenLinks.isPfostenAnEcke, "soll der Eckpfosten sein");
};

export const testEinfügenDoppeltorInStreckeIndex1: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 7;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  APP.arrangement.setSelectedObjects(agt.getElemente()[1]);
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  assert.deepEquals(
    [],
    agt.warnungen.map((w) => w.text)
  );
};

export const testEinfügenEinzeltorInRechteckIndex2: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 7;
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, false, false]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  APP.arrangement.setSelectedObjects(agt.getElemente()[2]);
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  // fixme mit dem 2. Update geht es!
  agt.update3d();
  assert.deepEquals(
    [],
    agt.warnungen.map((w) => w.text)
  );
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
  assertSegmentIstLückenlosGefüllt(agt.segmente[1]);
};

export const testEinfügenEinzeltorInRechteckIndex4: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 7;
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("StandardRechts");
  agt.grundriss.setStandardForm("Rechteck", [breite, breite], [true, true, false, false]);
  agt.update3d();
  APP.arrangement.setSelectedObjects(agt.getElemente()[4]);
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  // fixme mit dem 2. Update geht es!
  agt.update3d();
  assert.deepEquals(
    [],
    agt.warnungen.map((w) => w.text)
  );
  const tor = agt.selectedObjects[0];
  assert.isTrue(tor.pfostenLinks.isPfostenAnEcke, "soll der Eckpfosten sein");
  const s = agt.segmente[0];
  const [x0, x1] = getMinMaxSegmentPartsX(s);
  const segmentEndenPfostenausgleich = _.sum(
    s.ecken.map((e) => getSegmentEndenAusgleichForEcke(e))
  );
  const istBreite = x1 - x0;
  const sollBreite = s.breite - segmentEndenPfostenausgleich;
  console.log({
    segmentEndenAusgleich: s.ecken.map((e) => getSegmentEndenAusgleichForEcke(e)),
    breite: s.breite,
    minMax: s.getMinMax(),
    x0,
    x1,
    istBreite,
    sollBreite,
    segmentEndenPfostenausgleich,
  });
  s.logit();
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
  assertSegmentIstLückenlosGefüllt(agt.segmente[1]);
};

export const testEinfügenEinzeltorInStreckeIndex1: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 7;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  APP.arrangement.setSelectedObjects(agt.getElemente()[1]);
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  assert.deepEquals(
    [],
    agt.warnungen.map((w) => w.text)
  );
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
};
